export class KeyboardConstants {
  static KEYDOWN_CODE = '40';
  static KEYUP_CODE = '38';
  static ENTER_CODE = '13';

  // Utilized in KeyboardShortcutSupportInitialization
  static KEY_S = 's';
  static KEY_P = 'p';
}
